import LeagueSeasonLeaderboardIndex from './LeagueSeasonLeaderboardIndex';
import LeagueSeasonLeaderboardCreate from './LeagueSeasonLeaderboardCreate';
import LeagueSeasonLeaderboardSettings from './LeagueSeasonLeaderboardSettings';
import LeagueSeasonLeaderboardSingle from './LeagueSeasonLeaderboardSingle';

export default function (app) {

    const settings = LeagueSeasonLeaderboardSettings;

    app.addModel({
        name: settings.key,
        path: settings.path,
        modelName: settings.modelName,
        endpoint: settings.endpoint,
        idKey: settings.idKey,
        primaryKey: settings.primaryKey,
    });

    // app.addMenu({
    //     key: settings.key,
    //     zone: settings.zone,
    //     label: settings.title,
    //     priority: 14,
    //     items: [
    //         {
    //             label: "All",
    //             path: settings.path,
    //             caps: settings.indexCaps
    //         },
    //         {
    //             label: "Add New",
    //             path: settings.path + "/create",
    //             caps: settings.createCaps
    //         }
    //     ],
    // });

    LeagueSeasonLeaderboardIndex(app, settings);

    LeagueSeasonLeaderboardCreate(app, settings);

    LeagueSeasonLeaderboardSingle(app, settings);

}